import $ from 'jquery';

function initMasonry() {
    $('.b-museum-media').removeClass('slider');
	$('.js-media-masonry-wrap').masonry({
		itemSelector: '.js-media-item',
		columnWidth: '.js-media-item'
	});
}

function initSlider() {
    $('.b-museum-media').addClass('slider');
	$('.js-museum-media-slider').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 4,
        arrows: true,
        infinite: false,
        centerMode: true,
        variableWidth: false,
        responsive: [
        {
            breakpoint: 1023,
            settings: {
                dots: false,
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            arrows: true,
	            infinite: false,
	            centerMode: false,
    			variableWidth: false,
           }
        },
        {
            breakpoint: 520,
            settings: {
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
	            centerMode: false,
    			variableWidth: false,
           }
        }
        ]
    });
}

$(document).ready(function() {
	if ($(window).width() >= 1024) {
		initMasonry();
	} else {
		initSlider();
	}
    $(document).on('click', '.js-media-option', function() {
    	$('.js-media-option').removeClass('active');
    	$(this).addClass('active');
    });
    $(document).on('click', '.js-media-slider-option', function() {
    	$('.js-media-masonry-wrap').masonry('destroy');
    	initSlider();
    });
    $(document).on('click', '.js-media-masonry-option', function() {
    	$('.js-museum-media-slider').slick('unslick');
    	initMasonry();
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-media.js